import { useTranslation } from 'react-i18next';
import SelectPanel from '@lib/components/SelectPanel/SelectPanel';
import { GetLoadOptions } from '@lib/components/Select/types';
import { getOptionsArrayValidation } from '@lib/utils/validationUtils';
import { FieldItem } from '@lib/interfaces/form';
import formStyles from '@lib/assets/styles/Form.module.scss';
import { materialSymbolsOutlined } from '@lib/enums/common';
import { FieldNames } from '../enums';

export default function useFilterFields({
  getFormCategoriesLoadOptions,
}: {
  getFormCategoriesLoadOptions: GetLoadOptions;
}): FieldItem[] {
  const { t } = useTranslation();
  return [
    {
      name: FieldNames.FormCategories,
      label: t('form-category'),
      element: SelectPanel,
      validation: getOptionsArrayValidation({ t }),
      formItemClassName: formStyles.formColumnAuto,
      hideErrorsSpace: true,
      componentProps: {
        defaultOptions: false,
        getLoadOptions: getFormCategoriesLoadOptions,
        isAsync: true,
        isMulti: true,
        showTabs: true,
        buttonProps: {
          leftIcon: 'category',
          leftIconClassName: materialSymbolsOutlined,
        },
      },
      isOptionalFn: () => false,
    },
  ];
}

export { FieldNames } from '../enums';
